import { render, staticRenderFns } from "./bs-date-catcher.vue?vue&type=template&id=4c30e57e&"
import script from "./bs-date-catcher.ts?vue&type=script&lang=ts&"
export * from "./bs-date-catcher.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports